/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './cellular-device-overview.scss';

/* eslint-disable import/no-unresolved, import/default */

import cellularDeviceOverviewTemplate from './cellular-device-overview.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.farmer.cellularDeviceOverview', [])
    .directive('cellularDeviceOverview', CellularDeviceOverview)
    .name;

/*@ngInject*/
function CellularDeviceOverview() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            device: "="
        },
        controller: CellularDeviceOverviewController,
        controllerAs: 'vm',
        templateUrl: cellularDeviceOverviewTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function CellularDeviceOverviewController($scope, $filter, $log, types, agTypes, agUtils, userService, unitService) {// eslint-disable-line

    let vm = this;

    vm.loading = false;
    vm.temperaturesLoading = false;
    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.tempHistoryUnits = unitService.temperatureUnitSymbol();
    vm.agTypes = agTypes;

    vm.flotSettings = {
        smoothLines: true
    };
    vm.legendConfig = {};

    vm.latestValuesSubscriptionOptions = {
        callbacks: {
            onDataUpdated: onDataUpdated,
            onDataUpdateError: onDataUpdateError,
            dataLoading: (subscription) => {
                vm.temperaturesLoading = subscription.loadingData;
            }
        },
        useDashboardTimewindow: false
    };

    vm.resizeChart = resizeChart;

    $scope.$watch(() => { return vm.device ? vm.device.label : null; }, (title) => {
        if (vm.ctx && title) {
            reset();
            vm.ctx.widgetTitle = title + ' (' + agUtils.getFarmerDeviceName(vm.device.type) + '): Overview';
            createLatestValuesSubscription();
            updateChartSubscription();
        }
    });

    $scope.$on('$destroy', () => {
        reset();
    });

    function createLatestValuesSubscription() {
        let latestValuesSubscriptionsInfo = [{
            type: types.datasourceType.entity,
            entityType: types.entityType.device,
            entityId: vm.device.id.id,
            entityName: vm.device.name,
            timeseries: [
                {name: vm.agTypes.telemetry.spearSensor.temperature},
                {name: vm.agTypes.telemetry.spearSensor.ambientTemperature}
            ]
        }];
        vm.ctx.subscriptionApi.createSubscriptionFromInfo (
            types.widgetType.latest.value, latestValuesSubscriptionsInfo, vm.latestValuesSubscriptionOptions, false, true).then(
            (subscription) => {
                vm.latestValuesSubscription = subscription;
            }
        );
    }

    function updateChartSubscription() {
        vm.chartSubscriptionsInfo = [{
            type: types.datasourceType.entity,
            entityType: types.entityType.device,
            entityId: vm.device.id.id,
            entityName: vm.device.name,
            timeseries: [
                {
                    name: vm.agTypes.telemetry.spearSensor.ambientTemperature,
                    label: "Ambient Temperature",
                    color: agTypes.colors.minColor,
                    postFuncBody: unitService.temperaturePostprocessingFuncBody()
                },
                {
                    name: vm.agTypes.telemetry.spearSensor.temperature,
                    label: "Temperature",
                    color: agTypes.colors.maxColor,
                    postFuncBody: unitService.temperaturePostprocessingFuncBody()
                }
            ]
        }];
    }

    function onDataUpdated(subscription) {
        let data = subscription.data;
        for (let i = 0; i < data.length; i++) {
            let datasourceData = data[i];
            let val = getNumberValue(datasourceData);
            var ts;
            if (val != "-") {
                ts = getFormattedTs(datasourceData);
            } else {
                ts = "-";
            }
            switch (datasourceData.dataKey.name) {
                case vm.agTypes.telemetry.spearSensor.temperature:
                    vm.sampleTempTs = ts;
                    vm.sampleTemp = vm.ctx.utils.formatValue(unitService.toUserTemperature(val), 1, '') + vm.tempHistoryUnits;
                    break;
                case vm.agTypes.telemetry.spearSensor.ambientTemperature:
                    vm.ambientTempTs = ts;
                    vm.ambientTemp = vm.ctx.utils.formatValue(unitService.toUserTemperature(val), 1, '') + vm.tempHistoryUnits;
                    break;
            }
        }
        $scope.$digest();
    }

    function onDataUpdateError(subscription, e) {
        $log.error(e);
    }

    $scope.$on('$destroy', () => {
        reset();
    });

    function reset() {
        if (vm.latestValuesSubscription) {
            vm.ctx.subscriptionApi.removeSubscription(vm.latestValuesSubscription.id);
        }
        resetValues();
    }

    function resetValues() {
        vm.ambientTemp = '';
        vm.sampleTemp = '';
        vm.ambientTempTs = '';
        vm.sampleTempTs = '';
    }

    function getNumberValue(keyData) {
        if (keyData && keyData.data && keyData.data[0] && angular.isDefined(keyData.data[0][1]) && keyData.data[0][1] !== null) {
            if (!isNaN(keyData.data[0][1])) {
                return Number(keyData.data[0][1]);
            } else {
                return "-";
            }
        } else {
            return "-";
        }
    }

    function getFormattedTs(keyData) {
        if (keyData && keyData.data && keyData.data[0] && angular.isDefined(keyData.data[0][0])) {
            if (!isNaN(keyData.data[0][0])) {
                var ts = Number(keyData.data[0][0]);
                return $filter('date')(ts, 'dd/MM/yy HH:mm');
            } else {
                return '';
            }
        } else {
            return '';
        }
    }

    function resizeChart() {
        $scope.$broadcast("resize");
    }
}